import * as api from "@/api/paralloy/rbi";
import { addAttachment } from "@/api/welds";
import { InspectorContext } from "./reducer";
import { InspectorRow } from "@/api/paralloy/rbi";
import { InspectorState } from "./types";
import { Page } from "@/util";
import { useContext } from "react";
import { useMutation, useQuery } from "react-query";

export function useGetWeldList(state: InspectorState, skip: number, take: number) {
  const subProjectId = state.subProject?.id ?? "";
  const datasheetId = state.datasheet?.datasheetId ?? "";
  const filters = { ...state.filters, datasheetId, skip, take };

  return useQuery({
    queryKey: ["rbi/inspector/welds", { subProjectId, filters }],
    queryFn: () => api.getInspectorWeldList(subProjectId, filters),
  });
}

export function useGetInspections(weldIds: string[]) {
  const { updateState } = useContext(InspectorContext);
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["rbi/inspector/inspections", { weldIds }],
    queryFn: () => api.getInspections(weldIds),
    onSuccess: (data) => {
      updateState({ type: "Inspections", payload: data });
    },
  });
}

export function useSave() {
  return useMutation(async (inspections: InspectorRow[]) => {
    await api.saveInspectorRows(inspections);
    await saveAttachments(inspections);
    Page.redirect("rbi/paralloy/inspector");
  });
}

function saveAttachments(inspections: InspectorRow[]) {
  return Promise.all(
    inspections.map(async (row) => {
      if (row.attachment) {
        await addAttachment(row.weldId, row.attachment);
      }
    })
  );
}
